import { useState, useEffect, createRef } from "react";
import QRCode from "qrcode.react";
import YouTube from "react-youtube";
import moment from "moment";
import { nanoid } from "nanoid";
import Modal from "react-modal";
import firebase from "../firebase/firebase";
import { MyList } from "../styles/styles";

import tv from "../assets/tv.png";
import closeIcon from "../assets/close.svg";

const getYoutubeId = (url) => {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
};

const TvApp = () => {
  const [snapDoc, setSnapDoc] = useState(null);

  const [scanModal, setScanModal] = useState(false);
  const [qrcodeScanned, setQrcodeScanned] = useState(
    window.innerWidth <= 648 ? true : false
  );
  // const [qrcodeScanned, setQrcodeScanned] = useState(false);
  const [qrcodeUrl, setQrcodeUrl] = useState(null);
  const [qrcodeValue, setQrcodeValue] = useState(null);
  const [showlist, setShowlist] = useState(false);

  const [ytPlayer, setYtPlayer] = useState(null);

  const [tempActiveChannel, setTempActiveChannel] = useState(null);
  const [activeChannel, setActiveChannel] = useState(null);
  const [channelNo, setChannelNo] = useState(null);
  const [volume, setVolume] = useState(null);

  const defaultVideoId = getYoutubeId(
    "https://www.youtube.com/watch?v=1vZRDiBjFr8"
  );
  const [YTvideos, setYTvideos] = useState([]);

  const scrollRefs = YTvideos.reduce((acc, value) => {
    acc[value.id] = createRef();
    return acc;
  }, {});

  const videoOptions = {
    height: "100%",
    width: "100%",
    // https://developers.google.com/youtube/player_parameters
    playerVars: {
      autoplay: 1,
      controls: 0,
      disablekb: 1,
      enablejsapi: 1,
      fs: 1,
      loop: 1,
    },
  };

  const handleQrcode = async () => {
    const code = nanoid(20);
    // const code = "testetesstettetsetste"; // IMP Update uid
    setQrcodeValue(code);
    console.log(code);
    try {
      const data = {
        tv_qrcode: code,
        channel_no: 1,
        createdAt: new Date(),
      };

      setQrcodeUrl(`https://retro-cloud-tv.netlify.app/remote?qrcode=${code}`);

      await firebase.firestore().collection("tv_remote").doc(code).set(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getYTplaylistVideos = async () => {
    try {
      const config = await firebase
        .firestore()
        .collection("config")
        .doc("retro-tv-config")
        .get();
      // console.log(config.data());
      const { active_playlist, yt_api_key, max_results } = config.data();
      const ytPlaylistURL = `https://www.googleapis.com/youtube/v3/playlistItems?key=${yt_api_key}&playlistId=${active_playlist}&part=snippet,id&order=date&maxResults=${max_results}`;
      const fetchCall = await fetch(ytPlaylistURL);
      const videosJson = await fetchCall.json();
      const videos = [];

      videosJson.items.forEach((vid, idx) => {
        const data = {
          // id: idx + 1,
          id: vid.snippet.position + 1,
          name: vid.snippet.title,
          videoId: vid.snippet.resourceId.videoId,
        };

        videos.push(data);
      });

      setYTvideos(videos);
    } catch (error) {}
  };

  useEffect(() => {
    handleQrcode();
    getYTplaylistVideos();
  }, []);

  // useEffect(() => {
  //   if (ytPlayer) {
  //     console.log({ ytPlayer });
  //     ytPlayer.mute();
  //   }
  // }, [ytPlayer]);

  const handleForcePlay = () => {
    if (ytPlayer && window.innerWidth <= 648) {
      ytPlayer.playVideo();
    }
  };

  // START Firebase Call
  const updateChannelNo = async (newNo) => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ channel_no: newNo }); // NOTE IT WILL HANDLE by useEffect (onSnapshot)
    } catch (error) {
      console.log(error);
    }
  };

  const resetRemoteControl = () => {
    firebase
      .firestore()
      .collection("tv_remote")
      .doc(qrcodeValue)
      .update({ control_key: null });
  };

  const resetAllState = () => {
    setActiveChannel(null);
    setTempActiveChannel(null);
    setQrcodeScanned(false);
    setShowlist(false);
    setChannelNo(null);
  };

  const remoteKeyControl = (key) => {
    switch (key) {
      case "OFF":
        resetRemoteControl();
        resetAllState();
        break;

      case "GUIDE":
        handleGuide();
        resetRemoteControl();
        break;

      case "GUIDE_UP":
        handleChannel("minus");
        resetRemoteControl();
        break;

      case "GUIDE_DOWN":
        handleChannel("plus");
        resetRemoteControl();
        break;

      case "GUIDE_OK":
        handleOK();
        resetRemoteControl();
        break;

      case "VOL_UP":
        handleVolume("plus");
        resetRemoteControl();
        break;

      case "VOL_DOWN":
        handleVolume("minus");
        resetRemoteControl();
        break;

      default:
        break;
    }
  };

  const remotePlayChannel = (no, isFirst = false) => {
    setChannelNo(no);

    setTimeout(() => {
      const channel = YTvideos.find((x) => Number(x.id) === Number(no));
      setActiveChannel(channel || null);
      setChannelNo(null);

      console.log({ isFirst });
      if (isFirst) {
        setTimeout(() => {
          setScanModal(true);
          if (ytPlayer) {
            ytPlayer.pauseVideo();
          }
        }, 1000);
      }
    }, 1000);
  };

  useEffect(() => {
    if (snapDoc) {
      const { channel_no, scanned, control_key } = snapDoc;

      console.log(snapDoc);

      if (!qrcodeScanned && scanned) {
        setQrcodeScanned(true);
        remotePlayChannel(channel_no, true);
        return;
      }

      if (control_key) {
        remoteKeyControl(control_key);
        return;
      }

      if (channel_no) {
        remotePlayChannel(channel_no);
      }
    }
  }, [snapDoc]);

  useEffect(() => {
    if (!qrcodeValue) return;

    const unsubscribe = firebase
      .firestore()
      .collection("tv_remote")
      .doc(qrcodeValue)
      .onSnapshot((docSnap) => {
        if (docSnap.exists) {
          setSnapDoc(docSnap.data());
        }
      });

    return () => {
      firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ control_key: null });
      unsubscribe();
    };
  }, [qrcodeValue]);
  // END Firebase call

  const handleNoClick = (no) => {
    if (!qrcodeScanned) return;

    // setActiveChannel(null);
    const newNo = channelNo ? channelNo + no : no;
    updateChannelNo(newNo);
  };

  const handleScrollDiv = (id) => {
    scrollRefs[id].current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  const handleGuide = () => {
    if (!qrcodeScanned) return;

    setTempActiveChannel(activeChannel);
    setShowlist(!showlist);
  };

  const handleOK = async () => {
    if (!qrcodeScanned || !showlist || !tempActiveChannel) return;

    await updateChannelNo(tempActiveChannel.id);
    handleGuide();
  };

  const handleChannel = (type) => {
    if (!qrcodeScanned) return;

    if (showlist) {
      if (!activeChannel && !tempActiveChannel) {
        setTempActiveChannel(YTvideos[0]);
        return;
      }

      const idx = YTvideos.findIndex(
        (x) => Number(x.id) === Number(tempActiveChannel.id)
      );

      if (type === "plus") {
        if (idx === YTvideos.length - 1) return;
        setTempActiveChannel(YTvideos[idx + 1]);
      } else if (type === "minus") {
        if (idx === 0) return;
        setTempActiveChannel(YTvideos[idx - 1]);
      }

      handleScrollDiv(tempActiveChannel.id);
    } else {
      if (snapDoc?.channel_no) {
        let currNo = Number(snapDoc.channel_no);
        if (type === "plus") {
          updateChannelNo(currNo + 1);
        } else if (type === "minus") {
          if (currNo === 1) return;
          updateChannelNo(currNo - 1);
        }
      } else {
        updateChannelNo(1);
      }
    }
  };

  const toggleVolume = (vol) => {
    setVolume(vol);
    setTimeout(() => {
      setVolume(null);
    }, 1500);
  };

  const handleVolume = async (type) => {
    if (!qrcodeScanned || !ytPlayer) return;
    // console.log(ytPlayer);

    // if (ytPlayer.isMuted()) {
    //   ytPlayer.unMute();
    // }

    try {
      const currVol = await ytPlayer.getVolume();

      if (type === "plus") {
        if (currVol === 100) {
          toggleVolume(100);
          return;
        }
        toggleVolume(currVol + 10);
        ytPlayer.setVolume(currVol + 10);
      } else if (type === "minus") {
        if (currVol === 0) {
          toggleVolume(0);
          return;
        }
        toggleVolume(currVol - 10);
        ytPlayer.setVolume(currVol - 10);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // MODAL

  const modalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      zIndex: 100,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
    },
  };

  const closeScanModal = () => {
    setScanModal(false);
    setTimeout(() => {
      if (ytPlayer) {
        ytPlayer.playVideo();
      }
    }, 3000);
  };

  return (
    <section>
      <Modal
        isOpen={scanModal}
        //onRequestClose={closeScanModal}
        style={modalStyles}
        contentLabel="Scanned Modal"
      >
        <div className="text-center p-4">
          <h4 className="text-success">Connection established.</h4>
          <button onClick={closeScanModal} className="btn btn-success mt-4">
            OK
          </button>
        </div>
      </Modal>
      {/* SCREEN */}
      <div className="gif-tv">
        <div id="gif_tv_viewport" className="viewport">
          {qrcodeScanned && (
            <>
              <YouTube
                videoId={activeChannel ? activeChannel.videoId : defaultVideoId}
                opts={videoOptions}
                onReady={(e) => setYtPlayer(e.target)}
                onStateChange={(e) => console.log("On StateChange", e.data)}
                onEnd={(e) => console.log("On End", e.data)}
                onError={(e) => console.log("On Error", e.data)}
                className="video"
              />

              {showlist && (
                <div className="video channels-list">
                  <p className="list-text text-center">
                    Retro tv program guide
                  </p>
                  <div className="d-flex align-items-center">
                    <p className="list-text">{moment().format("ddd MMM DD")}</p>
                    <div className="mx-4">
                      {[1, 2, 3, 4, 5, 6].map((line, lIdx) => (
                        <div key={lIdx} className="green-line"></div>
                      ))}
                    </div>
                    <p className="list-text">{moment().format("hh:mm A")}</p>
                  </div>
                  <div className="list-scroll">
                    {YTvideos.map((item, index) => (
                      <MyList
                        ref={scrollRefs[item.id]}
                        key={index}
                        isActive={item.id === tempActiveChannel?.id}
                        title={item.videoUrl}
                      >
                        <p className="list-text">{`${item.id} ${item.name}`}</p>
                      </MyList>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          <div
            id="gif_tv_pixels"
            className="pixels"
            style={{
              backgroundImage:
                "url('https://res.cloudinary.com/cyborgspaceviking/image/upload/v1571119227/vhs-overlay_zpzs7x.png')",
            }}
          />
        </div>
        <img
          //className="tv"
          onClick={handleForcePlay}
          src={tv}
          alt="TV"
        />
        {!qrcodeScanned && qrcodeValue && (
          <div className="d-none d-md-block d-lg-block qrcode p-2 bg-white">
            <QRCode
              value={qrcodeUrl}
              //value={qrcodeValue}
              size={window.innerWidth > 648 ? 350 : 200}
              bgColor={"#ffffff"}
              fgColor={"#000000"}
              level={"L"}
              includeMargin={false}
              renderAs={"svg"}
            />
            <div onClick={() => setQrcodeScanned(true)} className="close">
              <img src={closeIcon} alt="close" />
            </div>
          </div>
        )}
        {/* PART RIGHT SIDE CONTROLS */}
        <div className="controls-wrapper">
          <div className="channels-buttons">
            {/* REMOTE BUTTONS */}
            <div className="nav-buttons">
              <div onClick={() => handleChannel("plus")} className="button top">
                <p>CH +</p>
              </div>
              <div
                onClick={() => handleVolume("plus")}
                className="button right"
              >
                <p>Vol +</p>
              </div>
              <div
                onClick={() => handleVolume("minus")}
                className="button left"
              >
                <p>Vol -</p>
              </div>
              <div
                onClick={() => handleChannel("minus")}
                className="button bottom"
              >
                <p>CH -</p>
              </div>
              <div className="center-button" />
              <div onClick={handleOK} className="ok-button">
                <p>OK</p>
              </div>
            </div>
            {/* GUIDE BUTTON */}
            <div onClick={handleGuide} className="guide-button">
              <p>TV GUIDE</p>
            </div>
          </div>
          <div className="channels-control">
            <div className="key-row">
              <div onClick={() => handleNoClick("1")} className="key">
                1
              </div>
              <div onClick={() => handleNoClick("2")} className="key">
                2
              </div>
              <div onClick={() => handleNoClick("3")} className="key">
                3
              </div>
            </div>
            <div className="key-row">
              <div onClick={() => handleNoClick("4")} className="key">
                4
              </div>
              <div onClick={() => handleNoClick("5")} className="key">
                5
              </div>
              <div onClick={() => handleNoClick("6")} className="key">
                6
              </div>
            </div>
            <div className="key-row">
              <div onClick={() => handleNoClick("7")} className="key">
                7
              </div>
              <div onClick={() => handleNoClick("8")} className="key">
                8
              </div>
              <div onClick={() => handleNoClick("9")} className="key">
                9
              </div>
            </div>
            <div onClick={() => handleNoClick("0")} className="key key-0">
              0
            </div>
          </div>
        </div>
        {/* PART Entered Channel Number */}
        {/* {qrcodeScanned && (
          <>
            {volume || volume == 0 ? (
              <div className="volume-no">{`VOL ${volume}`}</div>
            ) : channelNo ? (
              <div className="channel-no">{`CH ${channelNo}`}</div>
            ) : null}
          </>
        )} */}

        {qrcodeScanned && (volume || volume == 0) && (
          <div className="volume-no">{`VOL ${volume}`}</div>
        )}

        {qrcodeScanned && !volume && channelNo && (
          <div className="channel-no">{`CH ${channelNo}`}</div>
        )}
      </div>
    </section>
  );
};

export default TvApp;
